
export const mockCentros = [
    {
        id: 1,
        codigoCentro: "0012",
        codigoEspacio: "0012",
        tipoCentro: "Obra reforma",
        nima: "",
        cadena: "Edificio singular",
        fechaInicio: "15/02/2025",
        fechaFin: "11/07/2025",
        intermediario: "",
        responsable: "DIEGO RIVAS SERRANO",
        superficie: "760.00",
        observaciones: "",
    },
];

export const mockDocumentos = [
    {
        id: 1,
        tipoDocumento: "Certificado final de valorización",
        nombreArchivo: "Certificado-final-de-valorización_20250811180305.pdf",
        estado: "VALIDADO",
    },
    {
        id: 2,
        tipoDocumento: "DI/Albaranes",
        nombreArchivo: "Dis-residuos_20250811180337.pdf",
        estado: "VALIDADO",
    },
    {
        id: 3,
        tipoDocumento: "Factura",
        nombreArchivo: "Facturas_20250811180405.pdf",
        estado: "VALIDADO",
    },
    {
        id: 4,
        tipoDocumento: "Factura",
        nombreArchivo: "Abono-venta-metais-mesturados_20250811180502.pdf",
        estado: "VALIDADO",
    },
    {
        id: 5,
        tipoDocumento: "Otra documentación",
        nombreArchivo: "Contrato-de-tratamento_20250811180561.pdf",
        estado: "VALIDADO",
    },
    {
        id: 6,
        tipoDocumento: "Plan gestión de residuos",
        nombreArchivo: "Plan-de-xestión-de-residuos_20250811180616.pdf",
        estado: "VALIDADO",
    },
];

export const mockCumplimientoLegal = [
    {
        id: 1,
        descripcion: "Certificado final de valorización",
        estado: "VALIDADO",
    },
    {
        id: 2,
        descripcion: "Factura",
        estado: "VALIDADO",
    },
    {
        id: 3,
        descripcion: "DI/Albaranes",
        estado: "VALIDADO",
    },
];

export const mockResiduos = {
    chartData: {
        Semana: [
            { name: "Envases", uv: 15, pv: 24, amt: 24 },
            { name: "Vidrio", uv: 8, pv: 13, amt: 22 },
            { name: "Hormigón", uv: 62, pv: 98, amt: 22 },
            { name: "Madera", uv: 25, pv: 39, amt: 20 },
            { name: "Metales", uv: 18, pv: 48, amt: 21 },
        ],
        Mes: [
            { name: "Envases", uv: 150, pv: 120, amt: 110 },
            { name: "Vidrio", uv: 80, pv: 140, amt: 130 },
            { name: "Hormigón", uv: 620, pv: 135, amt: 125 },
            { name: "Madera", uv: 250, pv: 160, amt: 150 },
            { name: "Metales", uv: 180, pv: 160, amt: 150 },
        ],
        Año: [
            { name: "Envases", uv: 1500, pv: 2400, amt: 2400 },
            { name: "Vidrio", uv: 800, pv: 1398, amt: 2210 },
            { name: "Hormigón", uv: 6200, pv: 9800, amt: 2290 },
            { name: "Madera", uv: 2500, pv: 3908, amt: 2000 },
            { name: "Metales", uv: 1800, pv: 4800, amt: 2181 },
        ],
    },
    valoracion: 86.99,
    eliminacion: 13.01,
    sinDatos: 0.0,
};

export const mockResiduosAgrupados = [
    {
        id: 1,
        residuo: "150110 - ENVASES VACÍOS CONTAMINADOS",
        peso: "80.000 kg",
        valorizacion: "80.000 / 80.000 kg",
        costeFinal: "144.00 €",
    },
    {
        id: 2,
        residuo: "080111 - RESIDUOS DE PINTURA Y BARNIZ QUE CO...",
        peso: "135.000 kg",
        valorizacion: "135.000 / 135.000 kg",
        costeFinal: "255.50 €",
    },
    {
        id: 3,
        residuo: "160504 - AEROSOLES VACÍOS (ANT)",
        peso: "6.000 kg",
        valorizacion: "6.000 / 6.000 kg",
        costeFinal: "101.00 €",
    },
    {
        id: 4,
        residuo: "200121 - TUBOS FLUORESCENTES",
        peso: "65.000 kg",
        valorizacion: "65.000 / 65.000 kg",
        costeFinal: "80.00 €",
    },
    {
        id: 5,
        residuo: "200136 - EQUIPOS ELÉCTRICOS Y ELECTRÓNICOS D...",
        peso: "2.500 tn",
        valorizacion: "2.500 / 2.500 tn",
        costeFinal: "80.00 €",
    },
];

export const mockResiduosGenerados = [
    {
        id: 1,
        residuo: "080111 - RESIDUOS DE PINTURA Y BARNIZ QUE CO...",
        fechaRecogida: "18/06/2025",
        peso: "135.000 kg",
        valorizacion: "135.000 / 135.000 kg",
        costeFinal: "255.50 €",
        validacion: "VALIDADO",
    },
    {
        id: 2,
        residuo: "150101 - ENVASES DE PAPEL Y CARTÓN",
        fechaRecogida: "25/06/2025",
        peso: "0.300 tn",
        valorizacion: "0.285 / 0.300 tn",
        costeFinal: "0.00 €",
        validacion: "VALIDADO",
    },
    {
        id: 3,
        residuo: "150102 - PLÁSTICO",
        fechaRecogida: "25/06/2025",
        peso: "0.105 tn",
        valorizacion: "0.100 / 0.105 tn",
        costeFinal: "0.00 €",
        validacion: "VALIDADO",
    },
    {
        id: 4,
        residuo: "150110 - ENVASES VACÍOS CONTAMINADOS",
        fechaRecogida: "18/06/2025",
        peso: "80.000 kg",
        valorizacion: "80.000 / 80.000 kg",
        costeFinal: "144.00 €",
        validacion: "VALIDADO",
    },
    {
        id: 5,
        residuo: "160504 - AEROSOLES VACÍOS (ANT)",
        fechaRecogida: "18/06/2025",
        peso: "6.000 kg",
        valorizacion: "6.000 / 6.000 kg",
        costeFinal: "101.00 €",
        validacion: "VALIDADO",
    },
    {
        id: 6,
        residuo: "170107 - RCD MEZCLA LIMPIA",
        fechaRecogida: "25/06/2025",
        peso: "25.000 tn",
        valorizacion: "20.000 / 25.000 tn",
        costeFinal: "3175.00 €",
        validacion: "VALIDADO",
    },
    {
        id: 7,
        residuo: "170201 - MADERA",
        fechaRecogida: "25/06/2025",
        peso: "18.000 tn",
        valorizacion: "12.600 / 18.000 tn",
        costeFinal: "2016.00 €",
        validacion: "VALIDADO",
    },
    {
        id: 8,
        residuo: "170202 - VIDRIO",
        fechaRecogida: "25/06/2025",
        peso: "3.500 tn",
        valorizacion: "3.500 / 3.500 tn",
        costeFinal: "3034.00 €",
        validacion: "VALIDADO",
    },
    {
        id: 9,
        residuo: "170407 - METALES MEZCLADOS",
        fechaRecogida: "25/06/2025",
        peso: "5.000 tn",
        valorizacion: "4.750 / 5.000 tn",
        costeFinal: "-765.00 €",
        validacion: "VALIDADO",
    },
    {
        id: 10,
        residuo: "170604 - MATERIALES DE AISLAMIENTO DISTINTOS...",
        fechaRecogida: "25/06/2025",
        peso: "1.100 tn",
        valorizacion: "0.000 / 1.100 tn",
        costeFinal: "1228.70 €",
        validacion: "VALIDADO",
    },
];

export const mockTarifas = [
    {
        id: 1,
        gestor: "ZAC S.R.L.",
        tarifa: "Sin asignar",
    },
    {
        id: 2,
        gestor: "TRF- TRANSPORTISTA",
        tarifa: "Sin asignar",
    },
    {
        id: 3,
        gestor: "TRIU, S.A.",
        tarifa: "Sin asignar",
    },
    {
        id: 4,
        gestor: "YENİ KAYA DEMİR ÇELİK İNŞAAT GİDA. SAN. TİC. LTD.",
        tarifa: "Sin asignar",
    },
    {
        id: 5,
        gestor: "ZAC S.R.L.",
        tarifa: "Sin asignar",
    },
    {
        id: 6,
        gestor: "TRF",
        tarifa: "Sin asignar",
    },
    {
        id: 7,
        gestor: "RİP.AM. SRL",
        tarifa: "Sin asignar",
    },
    {
        id: 8,
        gestor: "YENİ KAYA DEMİR ÇELİK İNŞAAT GİDA. SAN. TİC. LTD.",
        tarifa: "Sin asignar",
    },
];

export const tarifaOptions = [
    { value: "sin_tarifa", label: "Sin tarifa" },
    { value: "tarifa_asignada", label: "Tarifa asignada" },
    { value: "tarifa_a", label: "Tarifa A" },
    { value: "tarifa_b", label: "Tarifa B" },
    { value: "tarifa_c", label: "Tarifa C" },
];
